import _Dropdown from "@hzero-front-ui/hzero-ui/lib/Dropdown";
import _Menu from "@hzero-front-ui/hzero-ui/lib/Menu";
import _Icon from "hzero-ui/lib/icon";
import React from 'react';
var TableAction = function TableAction(props) {
  var options = props.options,
    overlayTrigger = props.overlayTrigger;
  var getSubOptionTitle = function getSubOptionTitle(option) {
    return /*#__PURE__*/React.createElement("a", null, typeof option.icon === 'string' ? /*#__PURE__*/React.createElement(_Icon, {
      type: option.icon
    }) : option.icon || null, /*#__PURE__*/React.createElement("span", null, option.text));
  };
  var getSubMenuItems = function getSubMenuItems(opts) {
    return opts.map(function (opt) {
      return /*#__PURE__*/React.createElement(_Menu.Item, {
        key: opt.key,
        onClick: opt.action
      }, getSubOptionTitle(opt));
    });
  };
  var menu = /*#__PURE__*/React.createElement(_Menu, null, options.map(function (option) {
    return !option.subOptions || !option.subOptions.length ? /*#__PURE__*/React.createElement(_Menu.Item, {
      key: option.key,
      onClick: option.action
    }, getSubOptionTitle(option)) : /*#__PURE__*/React.createElement(_Menu.SubMenu, {
      key: option.key,
      title: getSubOptionTitle(option)
    }, getSubMenuItems(option.subOptions || []));
  }));
  return /*#__PURE__*/React.createElement(_Dropdown, {
    overlay: menu,
    trigger: overlayTrigger || ['click']
  }, /*#__PURE__*/React.createElement("a", {
    className: "ant-dropdown-link",
    href: "#"
  }, /*#__PURE__*/React.createElement(_Icon, {
    type: "operation",
    style: {
      fontSize: 16,
      color: "#5a6677"
    }
  })));
};
export default TableAction;